module.exports = __webpack_public_path__ + "img/small-gathering.92b964fd.svg";